// extracted by mini-css-extract-plugin
export default {"remval":"DaysRemaining_remval__LFZWm","remining":"DaysRemaining_remining__RHCEb"};